<!--
  该组件只支持单层级的数据选择，使用该组件时，需要指定idDim，同时需要在levelConfig中进行相关配置
  如果是需要多层级的数据选择，使用ids-select.vue
  该组件与ids-select.vue的差异之处在于ids-select.vue的搜索结果是放在下拉列表，而该组件是放在select-panel组件中
-->
<template>
  <div class="ids-select">
    <!-- 伪输入，展示区 -->
    <FakeInput
      :is-active="isIdsSelectShow"
      :value="idsSelectValueString"
      :placeholder="idsSelectPlaceholder"
      @click="() => { isIdsSelectShow = true }"
    />
    <!-- 弹窗，实际输入区 -->
    <byted-modal
      ref="select-panel-modal"
      v-model="isIdsSelectShow"
      :title="realModalTitle"
      :mask-closable="false"
      size="663px"
      class="dialog-ids-select"
    >
      <div slot="body">
        <div class="ids-select-content">
          <!-- 搜索 -->
          <byted-input
            v-model="searchInput"
            @change="debouncedSearch"
            prefix="search"
            placeholder="请输入名称或ID搜索"
            class="search-input"
          />
          <div
            v-byted-loading="isSelectPanelLoading"
            class="select-ids-panel"
            data-no-translate
          >
            <byted-select-panel
              ref="report-selected"
              v-show="!isSearchMode"
              v-model="selectedIds"
              :title="panelTitle"
              :options="panelOptions.children"
              :async="true"
              :auto-scroll="true"
              :has-check-all="false"
              :infinite="true"
              list-width="200px"
              @change="scrollToEnd"
              @loadmore="handleLoadMore"
              class="normal-select-panel"
            >
              <div slot="infinite-loading" slot-scope="{ level }" class="infinite-loading-wrapper">
                <div v-if="!hasMore" class="nomore">
                  没有更多了
                </div>
                <div v-else class="loading-data">
                  <byted-loading-icon size="md" />
                  <span class="loading-text">加载中...</span>
                </div>
              </div>
            </byted-select-panel>
            <byted-select-panel
              v-show="isSearchMode"
              ref="report-search-selected"
              v-byted-loading="isLoadingSearch"
              v-model="selectedIds"
              :title="panelTitle"
              :options="searchPanelOptions.children"
              :async="true"
              :auto-scroll="true"
              :has-check-all="false"
              :infinite="searchInfinite"
              list-width="200px"
              @change="scrollToEnd"
              @loadmore="handleSearchLoadMore"
              class="search-select-panel"
            >
              <div slot="infinite-loading" class="infinite-loading-wrapper">
                <div v-if="!hasMoreSearch" class="nomore">
                  没有更多了
                </div>
                <div v-else class="loading-data">
                  <byted-loading-icon size="md" />
                  <span class="loading-text">加载中...</span>
                </div>
              </div>
            </byted-select-panel>
          </div>
        </div>
      </div>
      <template slot="footer">
        <byted-button type="default" @click="closeIdsSelect">
          {{ $bp_t('取消', 'common.cancel') }}
        </byted-button>
        <byted-button type="info" @click="applyBtnHandler">
          {{ $bp_t('应用', 'common.application') }}
        </byted-button>
      </template>
    </byted-modal>
  </div>
</template>

<script>
import { ADVERTISER, getData, levelConfig } from './levelConfig.js'

import FakeInput from 'Src/components/reporter/input/fake-input.vue'

export default {
  name: 'IdsSelectSingle',
  components: { FakeInput },
  props: {
    idDim: {
      type: String,
      default: ADVERTISER
    },
    value: {
      type: Object,
      default: {},
    },
    modalTitle: {
      type: String,
      default: '',
    },
    searchInfinite: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    const realModalTitle = '选择' + (this.modalTitle ? this.modalTitle : levelConfig[this.idDim].label);
    return {
      realModalTitle: realModalTitle,
      idsSelectPlaceholder: $bp_t('请选择', 'common.please_choose') + (this.modalTitle ? this.modalTitle : levelConfig[this.idDim].label),
      panelTitle: [levelConfig[this.idDim].label],
      isIdsSelectShow: false,
      isSelectPanelLoading: false,
      panelOptions: { children: [] },
      searchPanelOptions: { children: [] },
      selectedIds: [],
      hasMoreMap: {},
      // 搜索相关
      isSearchMode: false,
      searchInput: '',
      searchLevel: this.idDim,
      isLoadingSearch: false,
      hasMore: true,
      hasMoreSearch: true,
    }
  },
  computed: {
    idsSelectValueString() {
      const selectedCount = this.value[levelConfig[this.idDim].valueKey]?.length ?? 0;
      return selectedCount ? $bp_t(`已选${selectedCount}项`, 'common.selected_filter_term', { data: selectedCount}) : '';
    },
  },
  watch: {
    isIdsSelectShow(newVal) {
      if (!newVal) return; // 关闭modal时
      initSelectedIds.call(this);
      initHasMoreMap.call(this);
      initSearchInput.call(this);
      if (this.idDim === ADVERTISER) {
        this.getPanelData({ page: 1 })
      } else {
        this.getPanelData({ lastId: -1})
      }

      function initSelectedIds() {
        this.selectedIds = this.value[levelConfig[this.idDim].valueKey].map(id => `${this.idDim}_${id}`)
      }
      function initHasMoreMap() {
        this.hasMore = true;
      }
      function initSearchInput() {
        this.isSearchMode = false;
        this.searchInput = '';
        this.searchLevel = this.idDim;
      }
    },
    isSearchMode() {
      this.scrollToEnd();
    }
  },
  created() {
    this.enrichLevelConfig()
  },
  mounted() {
    // bui的setSelectedDetail会bug，不需要用到detail, 重写
    this.$refs['report-selected'] && (this.$refs['report-selected'].setSelectedDetail = function () {
      return;
    })
    this.$refs['select-panel-modal']?.$el?.addEventListener('click', (e) => {
      //  阻断冒泡
      e.cancelBubble = true
      e.stopPropagation?.()
    })
    this.$refs['report-search-selected'].list = this.$refs['report-selected'].list;
  },
  methods: {
    enrichLevelConfig() {
      addFetchData.call(this)

      function addFetchData() {
        Object.entries(levelConfig).forEach(([level, config]) => {
          config.fetchData = level === ADVERTISER
            ? getAdvertisers.bind(this)
            : getLevelData.bind(this)
        })
        // 目前该组件只有账户的场景，除了账户的其他列表都使用lastId进行分页
        async function getLevelData(level, idList, lastId=-1) {
          return;
        }
        // 账户列表只有分页接口，没有全量接口，并且使用page进行分页
        async function getAdvertisers(page=1) {
          const { data: { accounts = [], pagination = {} } } = await getData({
            url: levelConfig[ADVERTISER].cascadePageUrl,
            data: {
              page: page,
              limit: levelConfig[ADVERTISER].pageLimit,
            }
          }, this);
          return {
            data: accounts.map(account => ({advertiser_id: account.id, advertiser_name: account.name})),
            total: pagination?.total ?? 0
          }
        }
      }
    },
    async getPanelData ({ lastId, page }) {
      const parentOption = this.panelOptions;
      // 如果首页数据已加载，不必重复加载
      if (parentOption.isLoaded && (lastId === -1 || page === 1)) {
        return;
      }
      this.isSelectPanelLoading = true;
      try {
        let lastIdOrPage;
        if (page !== undefined) {
          lastIdOrPage = page;
        } else if (lastId !== undefined) {
          lastIdOrPage = lastId;
        }
        const resp = await levelConfig[this.idDim].fetchData(lastIdOrPage);
        const { data: originData, total } = resp;
        const itemList = originData.map(aRecord => this.getPanelItem(aRecord, this.idDim))
        const finalList = this.panelOptions.children.concat(itemList);
        if (finalList.length >= total) {
          this.hasMore = false;
        } else {
          this.hasMore = true;
        }
        if (page !== undefined) {
          page += 1
        }
        this.setOptions(parentOption, finalList, total, page)
      } catch (error) {
        console.error(error)
      } finally {
        this.isSelectPanelLoading = false;
      }
    },
    setOptions (parent, itemList, total, page) {
      parent.children = itemList;
      parent.isLoaded = true;
      parent.total = total;
      if (page !== undefined) {
        parent.page = page;
      }
      this.$refs['report-selected'].updateOption(this.panelOptions.children)
    },
    getPanelItem (item, level) {
      const originId = item[levelConfig[level].id]
      const name = item[levelConfig[level].name]
      return {
        id: `${level}_${originId}`,
        originId: originId,
        name: name,
        children: undefined,
        renderName: (name) => {
          return (
            <byted-popover
              class="list-item-popover-wrapper"
              placement="right"
              trigger="hover"
              width="240px"
              hide-delay={0}
              transfer
            >
              <template slot="body">
                {name}
              </template>
              <span slot="reference" class="name">{name}</span>
            </byted-popover>
          )
        }
      }
    },
    async scrollToEnd() {
      await this.$nextTick();
      let selectedContainer;
      if (this.isSearchMode) {
        selectedContainer = document.querySelector('.search-select-panel .bui-select-panel-right .byted-select-panel-moduler-container')
      } else {
        selectedContainer = document.querySelector('.normal-select-panel .bui-select-panel-right .byted-select-panel-moduler-container')
      }
      if (selectedContainer) {
        selectedContainer.scrollTop = selectedContainer.scrollHeight;
      }
    },
    async handleLoadMore({ level, item, reset }) {
      const parent = this.panelOptions;
      if (parent.children.length >= parent.total) {
        this.hasMore = false;
        return reset();
      }
      const lastId = item[item.length - 1].originId;

      if (+level === 0 && this.idDim === ADVERTISER) {
        await this.getPanelData({ page: parent.page })
      } else {
        await this.getPanelData({ lastId: lastId })
      }
      reset();
    },
    closeIdsSelect() {
      this.isIdsSelectShow = false;
    },
    applyBtnHandler() {
      const changedValue = {
        [levelConfig[this.idDim].valueKey]: [],
      };
      this.selectedIds.forEach(id => {
        const [idLevel, idValue] = id.split('_');
        idLevel && idValue && changedValue[levelConfig[idLevel].valueKey].push(parseInt(idValue));
      })
      this.$emit('valueChanged', changedValue, this.$refs['report-selected']?.list);

      this.closeIdsSelect();
    },
    debouncedSearch: _.debounce(function () {
      this.search();
    }, 500),
    // 这个组件只适合单级的搜索，如果搜索的是第二级会有一定的问题
    async search() {
      if (!this.searchInput) {
        this.isSearchMode = false;
        return;
      }
      this.isSearchMode = true;
      this.isLoadingSearch = true;
      try {
        const options = {
          data: { keyword: this.searchInput, page: 1, limit: levelConfig[this.idDim].searchPageLimit, },
          url: levelConfig[this.idDim].searchUrl
        }
        const { data } = await getData(options, this);
        const suggestList = data[levelConfig[this.idDim].key] || [];
        this.searchPanelOptions.children = suggestList.map(aRecord => this.getPanelItem(aRecord, this.idDim))
        this.searchPanelOptions.total = data.pagination?.total ?? 0;
        this.searchPanelOptions.page = 1;
        this.hasMoreSearch = this.searchPanelOptions.children?.length < this.searchPanelOptions.total;
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoadingSearch = false;
      }
    },
    async handleSearchLoadMore({ level, reset }) {
      this.hasMoreSearch = this.searchPanelOptions.total >= this.searchPanelOptions.children?.length;
      if (this.searchPanelOptions.children.length >= this.searchPanelOptions.total) {
        this.hasMoreSearch = false;
        return reset();
      }
      const options = {
        data: { keyword: this.searchInput, page: this.searchPanelOptions.page + 1, limit: levelConfig[this.idDim].searchPageLimit, },
        url: levelConfig[this.idDim].searchUrl
      }
      try {
        const { data } = await getData(options, this);
        const suggestList = data[levelConfig[this.idDim].key] || [];
        this.searchPanelOptions.children.push(...suggestList.map(aRecord => this.getPanelItem(aRecord, this.idDim)))
        this.hasMoreSearch = this.searchPanelOptions.children?.length < this.searchPanelOptions.total;
        this.$refs['report-search-selected'].updateOption(this.searchPanelOptions.children)
        this.searchPanelOptions.page += 1;
        reset();
      } catch (err) {
        console.error(err)
      }
    },

  }
};
</script>

<style lang="scss" scoped>
@import "src/basic/theme.scss";

.dialog-ids-select {
  .bui-modal-dialog {
    width: 662px;
  }

  .ids-select-content {
    .search-input {
      width: 400px;
    }

    .search-level-select {
      width: 104px;
    }

    .select-ids-panel {
      margin-top: 16px;
    }

  }
}

.infinite-loading-wrapper {
  height: 34px;
  font-size: 12px;
  text-align: center;
  display: flex;
  justify-content: center;
  color: rgb(51, 138, 255);
  align-items: center;

  &.infinite-loading-wrapper-nomore {
    height: 8px;
  }

  .nomore {
    color: #c1c1c1;
  }

  .loading-data {
    display: flex;
    align-items: center;
    justify-content: center;

    .loading-text {
      margin-left: 4px;
    }
  }
}
.list-item-popover-wrapper {
  max-width: 100%;

  .name {
    vertical-align: top;
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
